import { resolvers } from 'craft/resolvers';

export const richTextResolver = resolvers.RichText;
export const elementsResolvers = [
  resolvers.Link,
  resolvers.List,
  resolvers.ListItem,
  resolvers.Typography,
  resolvers.Variable,
];
export const internalNodesResolvers = [richTextResolver, ...elementsResolvers];
export const leafResolver = resolvers.Text;
export const rteChildrenResolvers = [...elementsResolvers, leafResolver];
export const rteResolvers = [richTextResolver, ...rteChildrenResolvers];
